if (import.meta.hot) {
  import.meta.hot.accept();
}

import './quickcheck.scss';
import 'bootstrap/js/dist/collapse';

(() => {
  class QuickCheck {
    constructor(rootContainer) {
      this.rootContainer = rootContainer;
      this.historyContainer = this.rootContainer.querySelector('[data-function="tree-container"]');
      this.resultContainer = this.rootContainer.querySelector('[data-function="result-container"]');
      this.footnotesContainer = this.rootContainer.querySelector('[data-function="footnotes-container"]');
      this.resultText = this.rootContainer.querySelector('[data-function="result-text"]');
      this.questionTemplate = this.rootContainer.querySelector('[data-function="question-template"]');
      this.restartButtonContainer = this.rootContainer.querySelector('[data-function="restart-button-container"]') || null;
      this.restartButton = this.rootContainer.querySelector('button[data-function="restart-widget"]') || null;
      this.showRestartButton = false;
      this.questionCounter = 0;
      this.questionData = JSON.parse(this.rootContainer.dataset?.questions || '{"text": "Fehler: Keine Fragen-Konfiguration gefunden"}');
    }

    initialize() {
      this.showRestartButton =
        this.rootContainer.dataset?.showRestartbtn &&
        this.rootContainer.dataset?.showRestartbtn === '1';

      if (this.showRestartButton && this.restartButton !== null) {
        this.restartButton.addEventListener('click', () => {
          this.restartApp();
        });
      }

      this.renderStep(this.questionData);
    }

    renderStep(node) {
      if (!node) return;

      // check node type
      if (node.type === 'result') {
        this.resultText.innerHTML = node.text;
        this.resultContainer.hidden = false;
        if (this.showRestartButton) {
          this.restartButtonContainer.hidden = false;
        }
        this.scrollToBottom();
        return;
      }

      if (node.type === 'question') {
        if (node?.footnote) {
          this.footnotesContainer.hidden = false;
          this.footnotesContainer.innerHTML = node.footnote;
        }

        this.questionCounter++;

        // clone question container from template
        const stepBlock = this.questionTemplate.content.firstElementChild.cloneNode(true);
        const questionText = stepBlock.querySelector('[data-function="question-text"]');
        questionText.dataset.questionnumber = this.questionCounter;
        questionText.innerHTML = node.text;

        // add button functionality
        const btnYes = stepBlock.querySelector('.qc-btn-yes');
        const btnNo = stepBlock.querySelector('.qc-btn-no');

        btnYes.addEventListener('click', () =>
          this.handleChoice(btnYes, btnNo, node.y),
        );
        btnNo.addEventListener('click', () =>
          this.handleChoice(btnNo, btnYes, node.n),
        );

        this.historyContainer.appendChild(stepBlock);

        this.scrollToBottom();
      }
    }

    // button animations
    handleChoice(clickedBtn, otherBtn, nextNode) {
      clickedBtn.disabled = true;
      otherBtn.disabled = true;

      otherBtn.classList.add('fade-out');
      clickedBtn.classList.add('clicked');

      setTimeout(() => {
        this.renderStep(nextNode);
      }, 600);
    }

    scrollToBottom() {
      this.rootContainer.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }

    // restart app
    restartApp() {
      this.historyContainer.innerHTML = '';
      this.footnotesContainer.innerHTML = '';
      this.resultContainer.hidden = true;
      if (this.showRestartButton) {
        this.restartButtonContainer.hidden = true;
      }
      this.questionCounter = 0;

      this.renderStep(this.questionData);
    }
  }

  // start app
  document.addEventListener('DOMContentLoaded', () => {
    const quickcheckWidgets = document.querySelectorAll('[data-function="quickcheck-widget"]');

    if (quickcheckWidgets.length === 0) {
      console.error('Quickcheck widget has no quickcheck instance.');
      return;
    }

    if (quickcheckWidgets.length > 0) {
      quickcheckWidgets.forEach((widget) => {
        const currentWidget = new QuickCheck(widget);
        currentWidget.initialize();
      });
    }
  });
})();
